let ws = null;
let timer = null;
let pingTimer = null;
let attempts = 0;
const listeners = new Set();

const emit = (ev) => listeners.forEach((fn) => { try { fn(ev); } catch (e) {} });

function schedule() {
  clearTimeout(timer);
  timer = setTimeout(connect, Math.min(30000, 1000 * 2 ** attempts++));
}

function connect() {
  const token = localStorage.getItem("cd_token");
  if (!token || listeners.size === 0) return;
  const base = process.env.REACT_APP_BACKEND_URL.replace(/^http/, "ws");
  try {
    ws = new WebSocket(`${base}/api/ws?token=${encodeURIComponent(token)}`);
  } catch (e) {
    return schedule();
  }
  ws.onopen = () => {
    attempts = 0;
    emit({ type: "ws", connected: true });
    clearInterval(pingTimer);
    pingTimer = setInterval(() => {
      if (ws && ws.readyState === WebSocket.OPEN) ws.send("ping");
    }, 25000);
  };
  ws.onmessage = (e) => {
    try { emit(JSON.parse(e.data)); } catch (err) {}
  };
  ws.onclose = () => {
    clearInterval(pingTimer);
    emit({ type: "ws", connected: false });
    if (listeners.size > 0) schedule();
  };
  ws.onerror = () => { try { ws.close(); } catch (e) {} };
}

export function subscribeRealtime(fn) {
  listeners.add(fn);
  if (!ws || ws.readyState === WebSocket.CLOSED || ws.readyState === WebSocket.CLOSING) connect();
  return () => listeners.delete(fn);
}

export const isRealtimeConnected = () => !!ws && ws.readyState === WebSocket.OPEN;
